export const SITE_NAME = 'GoodJob 職場透明化運動';
